require('./drawable.less');

var PageNoteView = require('./pageNote'),
    $ = require('jquery'),
    _ = require('underscore'),
    Util = require('../../../FV/util'),
    getContrastYIQ = Util.getContrastYIQ; // inc perf somewhat

/*
* Should further subclass ....
* 'User Icon': used to indicate if 'the derived user color from its groups' would apply,
* Only put an only on drawable note because for the other note types, we don't return groupOfDerivedCreationGroupUser.
* For the same reason, also don't:
* - give the user name a 'label' like background color
* - and don't have a user icon in front of each of the cusr labels
* Added background square -- can't show very light colors atop a white background.
* */


module.exports = PageNoteView.extend({


    ui: _.extend( {}, PageNoteView.prototype.ui, {

        bodyField:    '.noteSubject' // Note: I don't believe referenced, but left to indicate it's different on these noteTypes

    }),

    serializeData: function() {

        var context = PageNoteView.prototype.serializeData.apply( this, arguments );
        context.groupOfDerivedCreationGroupUser = context.note.getGroupOfDerivedCreationUserGroupColor();
        return context;

    },

    templateHelpers: _.extend( {}, PageNoteView.prototype.templateHelpers, {

        showUserColorIndicator: function() {

            return this.groupOfDerivedCreationGroupUser;

        },

        userColor: function() {

            if ( !this.groupOfDerivedCreationGroupUser )
                return null;

            return this.groupOfDerivedCreationGroupUser.getColor();

        },

        userColorContrast: function() {

            if ( !this.groupOfDerivedCreationGroupUser )
                return null;

            return getContrastYIQ( this.groupOfDerivedCreationGroupUser.getColor(), '#333') ; // (#555 same as csur color; a little darker b/c we make a bit opaque )

        },

        userColorIndicatorTitle: function() {

            if ( !this.groupOfDerivedCreationGroupUser )
                return null;

            return 'Shape color derived from ' + this.cuser + "'s membership in group " +
                this.groupOfDerivedCreationGroupUser.getName() + '.';

        }

    }),


    toggleKeyEvents: function( isUserDrawing ) {

        this[isUserDrawing ? 'unbindKeyboardEvents' : 'bindKeyboardEvents']();

    },

    /*
    * Note: the hover creating the event mediated could come from multi shapes, resulting in race conditions
    * (is entering/not is entering) --> don't use $.fn.toggleClass
    * */
    toggleNoteHighlight: function( isEntering ) {

        this.$el[isEntering ? 'addClass' : 'removeClass']('highlighted');

    },

    _postBaseToggleEditMode: function( isEntering ) {

        if ( isEntering ) {

            this.ui.noteSubject.setCursorEndOfText().removeClass('hide');
            // Swap the subject div and input
            // TODO: make class & state
            this.ui.subjectDiv.addClass('hide');

        }

    }

});






/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/drawableNote.js
 ** module id = 179
 ** module chunks = 0
 **/